import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TicketType } from 'src/app/app.consts';
import { BasicInfoService } from 'src/app/services/basic-info.service';

@Component({
  selector: 'app-application-steps',
  templateUrl: './application-steps.component.html',
  styleUrls: ['./application-steps.component.scss'],
})
export class ApplicationStepsComponent implements OnInit, OnDestroy {
  private subs: Array<Subscription> = [];
  showSteps = true;
  steps = [0, 1, 2];

  stepOneScreens = [
    '',
    'initial-screen',
    'basic-info',
    'company-association',
    'identification',
    'no-idin-bank',
    'big-ticket',
    'turnover',
    'high-amount-for-turnover',
  ];
  stepTwoScreens = [
    'start-improve',
    'purpose',
    'guarantor',
    'accounting-upload',
    'account-data',
    'channel',
    'securities',
    'other-securities',
    'summary',
    'real-estate',
    'big-purpose',
    'personal-contact',
  ];
  stepThreeScreens = ['3'];
  isMinasidor = false;

  constructor(
    private route: ActivatedRoute,
    private basicInfoService: BasicInfoService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.subs.push(
      this.router.events.subscribe((e) => {
        if (e instanceof NavigationEnd) {
          this.showSteps = !e.url.includes('unsubscribe');
        }
      })
    );

    this.subs.push(
      this.route.queryParams.subscribe((params) => {
        const { applicationId } = params;
        const minaSidorToken = params.token;

        if (minaSidorToken && applicationId) {
          this.isMinasidor = true;
        }
      })
    );
  }

  get isBigTicket(): boolean {
    if (this.basicInfoService.ticketType === TicketType.BIG) {
      return true;
    }
    return false;
  }

  getActiveStep(_index: number): boolean {
    // const path = this.router.url.split('/').pop() || '';
    // if (index === 0 && this.stepOneScreens.includes(path)) {
    //   return true;
    // } else if (index === 1 && this.stepTwoScreens.includes(path)) {
    //   return true;
    // } else {
    //   return index === 2 && this.stepThreeScreens.includes(path);
    // }
    return true;
  }

  ngOnDestroy(): void {
    this.subs.map((sub) => sub.unsubscribe());
  }
}
